import { useEffect, useState } from "react";
import styles from "./PanVerify.module.scss";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import { useSelector } from "react-redux";

// components
import MainHeader from "../../components/Header/MainHeader";

// methods
import useResponse from "../../hooks/useResponse";
import ServicesAPI from "../../services/services";
import { enterPanValidation } from "../../validations/user.validation";
import { googleEvent_LOJ018 } from "../../lib/google-analytics";
import { googleEvent_LOJ194 } from "../../lib/google-analytics-loan-journey-events";

export default function PanVerify() {
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const { panVerifyData } = useSelector((state) => state.register);

  const { handleStep } = useResponse();

  const { panConfirmation } = new ServicesAPI();

  useEffect(() => {
    googleEvent_LOJ194(panVerifyData?.pan_number);
    if (!panVerifyData) {
      navigate("/enter-your-pan");
    }
  }, [navigate, panVerifyData]);

  const handlePanConfirmation = async () => {
    setLoading(true);

    const res = await panConfirmation(panVerifyData?.pan_number);

    if (res) {
      handleStep();
    }

    setLoading(false);
  };

  return (
    <div className="wrapper auto-height">
      <MainHeader title="Pan Verification" />
      <Formik initialValues={{}} validationSchema={enterPanValidation} onSubmit={(values) => {}}>
        {({ errors, values, touched, isSubmitting, handleChange, handleBlur, handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <div className={styles.panVerifyStyles}>
              <div className="mb-2">
                <p className="label">PAN Number</p>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter your PAN"
                    name="pan"
                    value={panVerifyData?.pan_number}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    autoComplete="off"
                    readOnly
                  />

                  <div className={styles.check}>
                    <img src="/images/right.svg" alt="" />
                  </div>
                </div>
              </div>

              <div className="mb-2">
                <p className="label">Name</p>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter your Name"
                    name="pan"
                    value={panVerifyData?.full_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    autoComplete="off"
                    readOnly
                  />
                </div>
              </div>

              <div className="mb-2">
                <p className="label">D.O.B</p>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter your DOB"
                    name="pan"
                    value={panVerifyData?.dob}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    autoComplete="off"
                    readOnly
                  />
                </div>
              </div>

              <div className={styles.information}>
                <p>Are These Information Correct?</p>

                <div className={styles.buttons}>
                  <button
                    type={styles.button}
                    onClick={() => {
                      googleEvent_LOJ018("no", panVerifyData?.pan_number);
                      navigate("/enter-your-pan");
                    }}
                  >
                    No
                  </button>
                  <button
                    type="submit"
                    onClick={() => {
                      googleEvent_LOJ018("yes", panVerifyData?.pan_number);
                      handlePanConfirmation();
                    }}
                  >
                    Yes
                  </button>
                </div>
              </div>

              <br />
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
}
